var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unit-denominators"},[_c('denom-table',{attrs:{"header":_vm.header,"columns":_vm.columns,"checker":_vm.checker,"optional":_vm.optional,"code":_vm.code,"module":_vm.module},on:{"progress":_vm.progress},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }